import { getDepartementFromLongName } from "./department";
import { getRegionFromLongName } from "./region";
const domTomCountryCodes = ['RE', 'GP', 'MQ', 'GF', 'YT', 'BL', 'MF', 'NC', 'PF', 'PM', 'TF', 'WF'];
export class LocationFormModel {
    static fromGooglePlaces(place) {
        var _a, _b, _c;
        if (!place || !place.address_components || !place.formatted_address || !place.geometry) {
            return null;
        }
        const loc = new LocationFormModel();
        const resolve = fromGoogleAddressComponentsResolver(place.address_components);
        loc.formattedAddress = place.formatted_address;
        loc.streetNumber = resolve('street_number');
        loc.route = resolve('route');
        loc.postalCode = resolve('postal_code');
        loc.city = resolve('locality');
        loc.country = resolve('country');
        loc.countryShort = resolve('country', 'short');
        if (domTomCountryCodes.includes(loc.countryShort)) {
            // pour les DOM-TOM, on enregistre le pays comme région et département,
            // et un arrondissement
            loc.department = loc.country;
            loc.departmentCode = (_a = getDepartementFromLongName(loc.country)) === null || _a === void 0 ? void 0 : _a.num_dep;
            loc.region = loc.country;
            loc.regionShort = loc.countryShort;
            if (loc.city) {
                loc.arrondissementDOM = resolve('administrative_area_level_1');
            }
        }
        else {
            loc.department = resolve('administrative_area_level_2');
            const dptRef = getDepartementFromLongName(loc.department);
            loc.departmentCode = dptRef === null || dptRef === void 0 ? void 0 : dptRef.num_dep;
            loc.region = resolve('administrative_area_level_1');
            loc.regionShort = (_c = (_b = getRegionFromLongName(loc.region)) === null || _b === void 0 ? void 0 : _b.region_code) !== null && _c !== void 0 ? _c : resolve('administrative_area_level_1', 'short');
        }
        const gLatLng = place.geometry.location.toJSON();
        loc.coordinates = {
            lat: gLatLng.lat,
            lon: gLatLng.lng
        };
        loc.gmPlaceId = place.place_id;
        return loc;
    }
}
export class LocationDBModel {
}
const fromGoogleAddressComponentsResolver = (addressComponents) => (item, type = 'long') => {
    const comp = addressComponents.find(comp => comp.types.includes(item));
    return type === 'long' ? comp === null || comp === void 0 ? void 0 : comp.long_name : comp === null || comp === void 0 ? void 0 : comp.short_name;
};
export class LocationElasticSearchModel {
    static fromILocation({ postalCode, city, arrondissementDOM, departmentCode, region, regionShort, country, countryShort, coordinates, gmPlaceId }) {
        const viewModel = new LocationElasticSearchModel();
        viewModel.coordinates = {
            lat: coordinates.lat,
            lon: coordinates.lon
        };
        viewModel.geoShape = {
            type: 'point',
            coordinates: [coordinates.lon, coordinates.lat]
        };
        viewModel.postalCode = postalCode;
        viewModel.city = city;
        viewModel.arrondissementDOM = arrondissementDOM;
        viewModel.departmentCode = departmentCode;
        viewModel.region = region;
        viewModel.regionShort = regionShort;
        viewModel.country = country;
        viewModel.countryShort = countryShort;
        return viewModel;
    }
}
export class LocationViewModel {
    static fromILocation({ postalCode, city, arrondissementDOM, departmentCode, region, regionShort, country, countryShort, coordinates, gmPlaceId }) {
        const viewModel = new LocationViewModel();
        viewModel.coordinates = coordinates;
        viewModel.postalCode = postalCode;
        viewModel.city = city;
        viewModel.arrondissementDOM = arrondissementDOM;
        viewModel.departmentCode = departmentCode;
        viewModel.region = region;
        viewModel.regionShort = regionShort;
        viewModel.country = country;
        viewModel.countryShort = countryShort;
        viewModel.gmPlaceId = gmPlaceId;
        const primary = city !== null && city !== void 0 ? city : arrondissementDOM;
        const secondary = domTomCountryCodes.includes(countryShort) ? region : departmentCode;
        viewModel.label = `${primary} (${secondary})`;
        return viewModel;
    }
}
